// The vocabulary a table configuration may use, and the values a column or instance gets when it leaves an
// optional declaration out.

export const COLUMN_TYPES = [
  'text',
  'numeric',
  'date',
  'link',
  'button',
  'split',
  'badge',
  'actions',
]
export const SORT_DIRECTIONS = ['ascending', 'descending']
export const HEADING_LEVELS = [1, 2, 3, 4]
export const DEFAULT_HEADING_LEVEL = 2
export const WRAP_POLICIES = ['wrap', 'nowrap', 'ellipsis']
export const DEFAULT_WRAP = 'wrap'
export const LOCK_EDGES = ['start', 'end']
export const SOURCE_MODES = ['client', 'page']
export const FILTER_TYPES = ['enum', 'numeric', 'date']
export const PAGE_ACTION_TREATMENTS = ['primary', 'secondary']
export const DENSITIES = ['comfortable', 'compact']
export const DEFAULT_DENSITY = 'comfortable'

// named aggregates; a column may instead declare a function of the complete matching set
export const SUMMARY_AGGREGATES = ['sum']

// a filterable column filters by its type unless it names another filter type
export const defaultFilterType = type => {
  if (type === 'numeric') return 'numeric'
  if (type === 'date') return 'date'
  return 'enum'
}

// initial widths in CSS pixels, by type
export const DEFAULT_WIDTHS = {
  text: 180,
  numeric: 110,
  date: 130,
  link: 190,
  button: 110,
  split: 160,
  badge: 140,
  actions: 64,
}
export const DEFAULT_LABELLED_ACTIONS_WIDTH = 140
export const DEFAULT_MIN_WIDTH = 80
export const DEFAULT_MAX_WIDTH = 480
export const DEFAULT_MENU_MIN_WIDTH = 160
